import {AfterContentInit, Directive, ElementRef, HostListener, inject, Input, OnDestroy} from "@angular/core";

@Directive({
    selector: "[messageAutoScroll]",
    standalone:true
})
export class MessageAutoScroll implements AfterContentInit, OnDestroy {
    @Input("lock-y-offset") public lockYOffset: number = 10;
    @Input("observe-attributes") public observeAttributes: string = "false";


    private _el = inject(ElementRef);
    private _isLocked: boolean = false;
    private mutationObserver: MutationObserver | undefined;

    public getObserveAttributes(): boolean {
        return this.observeAttributes !== "" && this.observeAttributes.toLowerCase() !== "false";
    }

    public ngAfterContentInit(): void {
        this.mutationObserver = new MutationObserver(() => {
            if (!this._isLocked) {
                this.scrollDown();
            }
        });
        this.mutationObserver.observe(this._el.nativeElement, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: this.getObserveAttributes(),
        });
    }

    public ngOnDestroy(): void {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }

    public forceScrollDown(): void {
        this.scrollDown();
    }

    public isLocked(): boolean {
      return this._isLocked;
    }

    private scrollDown(): void {
        this._el.nativeElement.scrollTop = this._el.nativeElement.scrollHeight;
    }

    @HostListener("scroll")
    protected scrollHandler(): void {
        const scrollFromBottom = this._el.nativeElement.scrollHeight - this._el.nativeElement.scrollTop - this._el.nativeElement.clientHeight;
        this._isLocked = scrollFromBottom > this.lockYOffset;
    }
}